/**
 * pickingListName — derive a human-readable name for a picking list.
 *
 * Iter 290zn (2026-06-03). Older lists were stored as "JC <short> materials"
 * which forced users to memorise hex IDs ("Nobody knows the job card
 * description off by head"). New flows write "<title> · materials
 * (<short_id>)" but legacy data lingers — so we upgrade the name at
 * render time when the linked JC is resolvable. Storage cleanup runs
 * via the admin migration endpoint POST /api/picking/admin/rename-legacy-names.
 *
 * jcMap: { [jobcard_id]: { id, title, short_id } } — typically built once
 *         per page load via Promise.all over the relevant jobcard ids.
 *         May be {} or null — function falls back to list.name.
 */
export function displayPickingListName(list, jcMap) {
  if (!list) return "";
  const stored = list.name || "";
  // Match the OLD template literally — "JC <token> materials".
  // The token can be any non-whitespace (short_ids are alphanumeric).
  const m = stored.match(/^JC\s+(\S+)\s+materials$/i);
  if (!m) return stored; // Not the legacy pattern → trust stored name.
  // Find the linked JC (prefer the one whose short_id matches the
  // token we matched; fall back to the first linked JC if none match).
  const ids = list.jobcard_ids || [];
  if (!ids.length || !jcMap) return stored;
  const target = ids
    .map((jid) => jcMap[jid])
    .find((j) => j && (j.short_id === m[1] || j.id === m[1]));
  const chosen = target || jcMap[ids[0]];
  if (!chosen || !chosen.title) return stored;
  return chosen.short_id
    ? `${chosen.title} · materials (${chosen.short_id})`
    : `${chosen.title} · materials`;
}
